import {useState, useCallback} from 'react';

import classnames from 'classnames';

import {ChevronDownIcon, ChevronRightIcon} from 'shells/icon';
import {Body} from 'shells/typography/body';

import type {LeadResearchSentiment} from 'nutshell-graphql-types';

import {normalizeSentimentToClass} from './helpers';

import styles from './lead-fit-reason-item.module.css';

type Props = {
    text: string;
    sentiment: LeadResearchSentiment;
    body: string;
};

export function LeadFitReasonItem(props: Props) {
    const [isExpanded, setIsExpanded] = useState(false);
    const sentimentClass = normalizeSentimentToClass(props.sentiment);
    const hasBody = props.body.length > 0;

    const handleToggle = useCallback(() => {
        if (hasBody) {
            setIsExpanded((prev) => !prev);
        }
    }, [hasBody]);

    const ChevronIcon = isExpanded ? ChevronDownIcon : ChevronRightIcon;

    return (
        <li className={styles.item}>
            <button
                type='button'
                className={classnames(styles.header, {
                    [styles['header--clickable']]: hasBody,
                })}
                onClick={handleToggle}
                disabled={!hasBody}
            >
                <span
                    className={classnames(styles.dot, styles[`dot--${sentimentClass}`])}
                    aria-hidden='true'
                />
                <span className={styles.text}>{props.text}</span>
                {hasBody && (
                    <ChevronIcon
                        size={12}
                        className={classnames(styles.chevron, {
                            [styles['chevron--visible']]: isExpanded,
                        })}
                        wrapWithDiv={false}
                    />
                )}
            </button>
            {isExpanded && hasBody && (
                <div className={styles.body}>
                    <Body size='small'>{props.body}</Body>
                </div>
            )}
        </li>
    );
}
